const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`3b8c3ef4f69ed7bcbd6aa1328d7b9c211c80132f1db147b41bbb4d2f298d12ef`, `3b8c3ef4f69ed7bcbd6aa1328d7b9c211c80132f1db147b41bbb4d2f298d12ef`, 1, 110), new Map([[`class`, `o-container--prose o-container--pad-inline u-pad-block-1`], [`content_class`, `o-rhythm`], [`alignment`, (context.has(`alignment`) ? context.get(`alignment`) : null)], [`has_background`, (context.has(`has_background`) ? context.get(`has_background`) : null)], [`vertical_alignment`, (context.has(`vertical_alignment`) ? context.get(`vertical_alignment`) : null)], [`media_width`, (context.has(`media_width`) ? context.get(`media_width`) : null)], [`is_image_fill`, (context.has(`is_image_fill`) ? context.get(`is_image_fill`) : null)], [`is_stacked_on_mobile`, (context.has(`is_stacked_on_mobile`) ? context.get(`is_stacked_on_mobile`) : null)], [`has_media_on_the_right`, (context.has(`has_media_on_the_right`) ? context.get(`has_media_on_the_right`) : null)]]), false, false, 1));
            }

            getTemplateName() {
                return `3b8c3ef4f69ed7bcbd6aa1328d7b9c211c80132f1db147b41bbb4d2f298d12ef`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `3b8c3ef4f69ed7bcbd6aa1328d7b9c211c80132f1db147b41bbb4d2f298d12ef`, ``);
            }
        }],
        [110, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `3b8c3ef4f69ed7bcbd6aa1328d7b9c211c80132f1db147b41bbb4d2f298d12ef`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`
    <p>Let’s start with some text before the block even starts.</p>

    <div class="wp-block-media-text
      `);
                if ((context.has(`alignment`) ? context.get(`alignment`) : null)) {
                    this.echo(this.env.getFilter('escape').traceableCallable(17, this.source)(...[this.env, (context.has(`alignment`) ? context.get(`alignment`) : null), `html`, null, true]));
                }
                this.echo(`      `);
                if ((context.has(`has_media_on_the_right`) ? context.get(`has_media_on_the_right`) : null)) {
                    this.echo(`has-media-on-the-right`);
                }
                this.echo(`      `);
                if ((context.has(`is_stacked_on_mobile`) ? context.get(`is_stacked_on_mobile`) : null)) {
                    this.echo(`is-stacked-on-mobile`);
                }
                this.echo(`      `);
                if ((context.has(`is_image_fill`) ? context.get(`is_image_fill`) : null)) {
                    this.echo(`is-image-fill`);
                }
                this.echo(`      `);
                if ((context.has(`vertical_alignment`) ? context.get(`vertical_alignment`) : null)) {
                    this.echo(`is-vertically-aligned-`);
                    this.echo(this.env.getFilter('escape').traceableCallable(21, this.source)(...[this.env, (context.has(`vertical_alignment`) ? context.get(`vertical_alignment`) : null), `html`, null, true]));
                }
                this.echo(`      `);
                if ((context.has(`has_background`) ? context.get(`has_background`) : null)) {
                    this.echo(`has-gray-lighter-background-color has-background`);
                }
                this.echo(`"
      `);
                if (!!((context.has(`media_width`) ? context.get(`media_width`) : null) && !this.compare((context.has(`media_width`) ? context.get(`media_width`) : null), 50))) {
                    this.echo(`style="
        grid-template-columns:`);
                    if ((context.has(`has_media_on_the_right`) ? context.get(`has_media_on_the_right`) : null)) {
                        this.echo(`auto `);
                        this.echo(this.env.getFilter('escape').traceableCallable(26, this.source)(...[this.env, (context.has(`media_width`) ? context.get(`media_width`) : null), `html`, null, true]));
                        this.echo(`%`);
                    }
                    else {
                        this.echo(this.env.getFilter('escape').traceableCallable(28, this.source)(...[this.env, (context.has(`media_width`) ? context.get(`media_width`) : null), `html`, null, true]));
                        this.echo(`% auto`);
                    }
                    this.echo(`"`);
                }
                this.echo(`>
      <figure class="wp-block-media-text__media"
        `);
                if ((context.has(`is_image_fill`) ? context.get(`is_image_fill`) : null)) {
                    this.echo(`style="background-image:url(/media/avatar-buster-b.jpg);background-position:50% 50%"`);
                }
                this.echo(`>
        <img decoding="async" src="/media/avatar-buster-b.jpg" alt="" class="size-full">
      </figure>
      <div class="wp-block-media-text__content">
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        <p>Suspendisse a est et ex consectetur pulvinar at in tortor. Maecenas id mauris magna.</p>
      </div>
    </div>

    <p>Here is some text that follows this block.</p>

  `);
            }

            getTemplateName() {
                return `3b8c3ef4f69ed7bcbd6aa1328d7b9c211c80132f1db147b41bbb4d2f298d12ef`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `3b8c3ef4f69ed7bcbd6aa1328d7b9c211c80132f1db147b41bbb4d2f298d12ef`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '3b8c3ef4f69ed7bcbd6aa1328d7b9c211c80132f1db147b41bbb4d2f298d12ef');

let template = env.loadTemplate('3b8c3ef4f69ed7bcbd6aa1328d7b9c211c80132f1db147b41bbb4d2f298d12ef');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/media-text.twig", args: context }
     );
     return rendered;;
};